import React, { useState, useEffect, useRef } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    Dialog,
    Grid,
    Box,
    DialogActions,
    DialogContent,
    DialogContentText,
    Divider,
    TextField,
    FormControl,
    DialogTitle,
} from "@material-ui/core";
import { connect } from "react-redux";
import { setLoading, setSnackInfo } from "../redux/actions/appAction";
import { CSVLink } from "react-csv";
import { Modal } from "antd";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import moment from "moment";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import HttpService from "../services/httpService";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { EyeFilled } from '@ant-design/icons';

const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 850,
    },
    textField: {
        width: 100,
    },
    paper: {
        padding: theme.spacing(2),
        margin: "auto",
        maxWidth: 400,
    },
    actionButton: {
        backgroundColor: "#F47E46", // Primary background color
        color: "#FFF2EB",          // Primary text color
        "&:hover": {
            backgroundColor: "#E36F3E", // Darkened version of #F47E46
            color: "#FFD9C7",           // Lightened version of #FFF2EB
        }
    },
    submitButton: {
        backgroundColor: '#F47E46 !important',  // Decorpot Orange
        color: 'white',            // White text
        '&:hover': {
          backgroundColor: '#E0663D !important', // Darker Orange on hover
        },
      },
    clearButton: {
        backgroundColor: '#FFF2EB !important',   // Light Beige
        color: '#1C375D !important',             // Decorpot Orange text
        '&:hover': {
          backgroundColor: '#E7BAD0 !important', // Light Pink on hover
        },
    },
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#1C375D",
        color: '#FFF2EB',
        fontWeight: "500"
    },
    body: {
        fontSize: 14,
        // border: '1px solid red'
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

const DetailsModalOfInwarding = (props) => {
    const [dataForNewInwardingApproval, setDataForNewInwardingApproval] =
        useState([]);
    const [value, setValue] = useState("");
    const [details, setDetails] = useState([]);
    const classes = useStyles();
    const [textContent, setTextContent] = useState("");
    const [procurementDetails, setProcurementDetails] = useState({});
    const [invoiceModal, setInvoiceModal] = useState(false);
    const [material, setMaterial] = useState({});
    const [updatedMat, setUpdatedMat] = useState(0);
    const [transportationCharge, setTransportationCharge] = useState(0);
    const [freightCharge, setFreightCharge] = useState(0);
    const [gstAmounts, setGstAmounts] = useState(0);
    const [gstOrginalAmount, setGstOriginalAmount] = useState(0);
    const [isGstUpdated, setIsGstUpdated] = useState(false);
    const [isUpdated, setIsUpdated] = useState({
        valuesUpdated: false,
    });
    const [isMaterialUpdated, setIsMaterialUpdated] = useState(false);
    const [materialOriginalPrice, setMaterialOriginalPrice] = useState([]);
    const [editableFields, setEditableFields] = useState({
        transportationCharge: transportationCharge,
        gstAmounts: gstAmounts,
        freightCharge: freightCharge,
    });
    const [selectedOrderId, setSelectedOrderId] = useState("");
    const [openApproveRemarksModal, setOpenApproveRemarksModal] =
        useState(false);
    const [openRejectRemarksModal, setOpenRejectRemarksModal] = useState(false);
    const [remarks, setRemarks] = useState("");
    const [rejectionReason, setRejectionReason] = useState("");
    const [openAllRemarksDailog, setOpenAllRemarksDailog] = useState(false);
    const [freightGstDetails, setFreightGstDetails] = useState({ type: "", rate: "0" });
    const [freightChargeWOGst, setFreightChargeWOGst] = useState(0);
    const freightGstPercent = ["0", "5", "12", "18", "28"];
    const [approvalType, setApprovalType] = useState("");
    const [approvingMaterialDetails,  setApprovingMaterialDetails] = useState(null);
    const [inwardingMap, setInwardingMap] = useState(new Map());
    const [isFilePreviewVisible, setIsFilePreviewVisible] = useState(false);

    const [openGRN, setOpenGRN] = useState(false);
    const [grnUrl, setGrnUrl] = useState("");

    const handleOpenGRN = () => {
        const rawUrl = props?.DETAILS?.InwardingRecords?.grnLink;
        const viewerUrl = `https://docs.google.com/gview?url=${encodeURIComponent(rawUrl)}&embedded=true`;
        setGrnUrl(viewerUrl);   // Use Google viewer instead
        setOpenGRN(true);
    };


    const handleCloseGRN = () => {
        setOpenGRN(false);
        setGrnUrl("");
    };

    const handleViewFile = () => {
        setIsFilePreviewVisible(!isFilePreviewVisible);
    };

    // Function to handle the change in GST Rates
    const freightGstRateChangeHandler = (event, value) => {
        setFreightGstDetails({ ...freightGstDetails, rate: value });
        // Calculate the percentage amount and add it to freightCharge
        let freightChargeWithGst = freightChargeWOGst + (+freightChargeWOGst * +value) / 100;
        setFreightCharge(freightChargeWithGst.toFixed(2));
        const procDetailObj = { ...procurementDetails };
        procDetailObj.grandTotal =
            procDetailObj?.grandTotal - freightCharge + +freightChargeWithGst;
        // procDetailObj.freight = +event.target.value;

        setProcurementDetails(procDetailObj);
        setEditableFields({
            ...editableFields,
            freightCharge: +freightChargeWithGst,
        });
        // const procurementObj = { ...procurementDetails };
        // procurementDetails.gstDetails[0].rate = value;
        // priceCal(details.materialIdOfInwarding._id, procurementDetails, details);
        // setProcurementDetails(procurementObj);
    }

    // Headers to for csv
    const headers = [
        { key: "orderId", label: "PO No." },
        { key: "inwardingId", label: "Inwarding Id" },
        { key: "inwardedDate", label: "Inwarded Date" },
        { key: "invoiceDate", label: "Invoice Date" },
        { key: "invoiceNumber", label: "Invoice N0" },
        { key: "poQty", label: "PO Qty" },
        { key: "inwardedQty", label: "Inwarded Qty" },
        { key: "gst", label: "GST" },
        { key: "freightCharges", label: "freightCharges" },
        { key: "totalValue", label: "Total Value" },
    ];

    // Function to open invoice Modal
    const openInvoiceModalHelper = (materialMap, data, value) => {
        setInvoiceModal(true);
        priceCal(materialMap, data, value);
    };

    useEffect(() => {
        openInvoiceModalHandler(props.DETAILS);
    }, []);

    // Function to get procurement Details based on the click on action button
    const openInvoiceModalHandler = async (value) => {
        setSelectedOrderId(value?.procurementId?.orderId);
        setDetails(value);
        props.setLoading(true);
        try {
            const result =
                await HttpService.getProcurementByOrderIdForInwarding(
                    value?.procurementId?.orderId
                );
            let payload = {
                procurementId: value?.procurementId?._id,
                inwardingRecordId: value.InwardingRecords._id,
            }
            
            const allInwardingData = await HttpService.getAllInwardingsOfProcurement(payload);
            let tempMap = new Map();
            for(let i=0; i<allInwardingData.data.length; i++){
                tempMap.set(allInwardingData.data[i].materialIdOfInwarding, allInwardingData.data[i].InwardingRecords);
            }
            if(tempMap.size === 0){
                // Display success message if the response was successful
                props.setSnackInfo( "No Inwarding Item to Show!", "info");
                props.CLOSE_MODAL_HANDLER();
                setInvoiceModal(false);
                return;
            }
            setInwardingMap(tempMap);
            
            setProcurementDetails(result.data);
            let arr = result?.data?.materials?.map((el) => el.requestedPrice);
            setMaterialOriginalPrice(arr);
            openInvoiceModalHelper(
                tempMap,
                result.data,
                value
            );
        } catch (error) {
            console.error(error);
            // props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error")
        }
        props.setLoading(false);
    };

    // Function to handle remarks input
    const remarksInputHandler = async (e) => {
        setRemarks(e.target.value);
        // if (e.target.value.trim() === "") return props.setSnackInfo("Please Enter Remarks", "error");
    };

    // A helper function to calculate the necessary fields when rate, gst, freight, or transportation charges are changed
    const priceCal = (materialMap, data, value) => {
        let total = 0;
        let subTotal = 0;
        let presicionDiff = 0;
        let toatlGstAmount = 0;
        let totalQty = 0;

        // Data here is proucrement's doc in all the details of procurement is stored
        data.materials.forEach((mat) => {
            if (
                materialMap.has(mat.materialId._id.toString())
            ) {
                mat.inwardedQty = materialMap.get(mat.materialId._id.toString()).inwardedQty
                mat.materialTotal =
                    +mat.inwardedQty *
                        +mat.requestedPrice || +mat.materialId.pricePerUnit;
                total += mat.materialTotal;
                totalQty += +value?.InwardingRecords?.inwardedQty;
                mat.inwardingRecordId = materialMap.get(mat.materialId._id.toString())._id;
                mat.isAdded = true;

            }
        });

        if (data.discount) {
            let discountAmount = (data.discount / 100) * total; // Calculate the discount amount
            total -= discountAmount;
        } else {
            data.discount = 0;
        }
        subTotal = total;

        if (data.gstRequired) {
            data.gstDetails.forEach((gstDetail) => {
                gstDetail.gstAmount = Number(
                    Number.parseFloat((gstDetail.rate * total) / 100).toFixed(2)
                );
                toatlGstAmount += gstDetail.gstAmount;
            });
            total = total + toatlGstAmount;
        } else {
            toatlGstAmount = 0;
        }

        if (value.InwardingRecords.freightCharge) {
            total = total + +value.InwardingRecords.freightCharge;
        } else {
            data.freight = 0;
        }

        if (data.transportationCharge) {
            total = total + data.transportationCharge;
        } else {
            data.transportationCharge = 0;
        }

        data.totalQty = +totalQty;
        data.subTotal = +subTotal;
        data.grandTotal = +total;
        presicionDiff =
            Number(total).toFixed(2) -
            Number(Number.parseFloat(subTotal).toFixed(2)) -
            Number(Number.parseFloat(toatlGstAmount).toFixed(2)) +
            Number(Number.parseFloat(data.discount).toFixed(2)) -
            Number(Number.parseFloat(data.transportationCharge).toFixed(2)) -
            Number(Number.parseFloat(data.freight).toFixed(2));
        data.presicionDiff = Number.parseFloat(presicionDiff).toFixed(2);
        setTransportationCharge(data?.transportationCharge);
        setFreightCharge(value.InwardingRecords.freightCharge);
        setFreightChargeWOGst(value.InwardingRecords.freightCharge);
        setGstAmounts(toatlGstAmount);
        setEditableFields({ ...editableFields, gstAmounts: data?.gstDetails });
        setUpdatedMat(data.grandTotal);
        setProcurementDetails(data);
        return data;
    };

    // Function to handle the action of finance the procurement status when it is submitted
    const handleFinanceInwardingAction = async () => {
        // Set loading state to true to indicate a process is ongoing
        props.setLoading(true);

        // Check if remarks are entered, if not show a warning and return
        if (remarks.trim().length === 0) {
            props.setSnackInfo(
                `Please Enter ${textContent} Remarks Before Submitting`,
                "warning"
            );
            props.setLoading(false);
            return;
        }

        // Create an object to hold the updated procurement details and status
        let updateObj = {
            status: value,
            approvalType,
            approvingMaterialDetails,
            remarks: remarks.trim(),
            freightCharge: freightCharge,
            freightChargeWOGst: freightChargeWOGst,
            freightGstDetails: freightGstDetails,
            procurementDetails: procurementDetails,
            ...details,
        };

        // If values have been updated, include price and GST modify the information in object
        if (isUpdated.valuesUpdated === true) {
            updateObj.isPricesUpdated = true;
            updateObj.isGstUpdated = isGstUpdated;
            updateObj.fields = editableFields;
        }

        // If materials have been updated, include the updated materials information
        if (isMaterialUpdated === true) {
            updateObj.isMaterialUpdated = isMaterialUpdated;
            updateObj.materials = procurementDetails?.materials;
        }

        try {
            // Send the finance action status request to the backend API
            if(approvalType === "Single"){
                const response = await HttpService.updateFinanceStatus(updateObj);
               
                // Display success message if the response was successful
                props.setSnackInfo(
                    response?.data?.msg ?? "Updated Successfully",
                    response?.data?.type ?? "success"
                );
                setFreightGstDetails({ ...freightGstDetails, rate: 0 });
                openInvoiceModalHandler(details);
            }else if(approvalType === "All"){
                updateObj.approvingMaterialsArr = [];
                procurementDetails.materials.forEach((mat) => {
                    if(inwardingMap.has(mat.materialId._id.toString()) && mat.isAdded){
                        updateObj.approvingMaterialsArr.push(mat);
                    }
                });

                const response = await HttpService.approveAllInwardingsBatch(updateObj);
                
                // Display success message if the response was successful
                props.setSnackInfo(
                    response?.data?.msg ?? "Updated Successfully",
                    response?.data?.type ?? "success"
                );
                props.CLOSE_MODAL_HANDLER();
                setInvoiceModal(false);
            }
        } catch (err) {
            console.error("Error -> ", err);

            // Display error message if something went wrong
            props.setSnackInfo(
                err?.response?.data?.msg ?? "Something went wrong",
                err?.response?.type ?? "error"
            );
        }

        // Close the remarks modal and reset remarks input
        setOpenApproveRemarksModal(false);
        setOpenRejectRemarksModal(false);
        setRejectionReason("");
        setRemarks("");

        // Set loading state to false to indicate the process has completed
        props.setLoading(false);
    };

    // function to handle price change of material
    const materialPriceChangeHandler = (index, event) => {
        if (+event.target.value <= 0)
            return props.setSnackInfo(
                "Please Enter Value Greater than 0",
                "warning"
            );

        // Set isMaterialUpdated to true
        setIsMaterialUpdated(true);
        setFreightGstDetails({ ...freightGstDetails, rate: 0 });

        // Check if the new price is greater than the original requested price
        if (+event.target.value > +materialOriginalPrice[index]) {
            // Display an error message and return if the new price is greater
            props.setSnackInfo(
                "New Rate can't be greater than original Requested Rate",
                "error"
            );
            return;
        }
        // Create a copy of procurementDetails
        const updatedProcurementDetails = { ...procurementDetails };
        // Update the requested price for the material at the specified index
        updatedProcurementDetails.materials[index].requestedPrice =
            event.target.value;

        // Initialize variables for calculations
        let total = 0;
        let subTotal = 0;
        let presicionDiff = 0;
        let toatlGstAmount = 0;
        let totalQty = 0;

        // Calculate total and total quantity for all materials
        updatedProcurementDetails.materials.forEach((mat, i) => {
            if (mat.isAdded === true) {
                // mat.materialTotal = +mat.requestedQuantity * +mat.requestedPrice || +mat.materialId.pricePerUnit;
                mat.materialTotal =
                    +mat?.inwardedQty *
                        +mat.requestedPrice || +mat.materialId.pricePerUnit;
                total += mat.materialTotal;
                // totalQty += mat.requestedQuantity;
                totalQty += details?.InwardingRecords?.inwardedQty;
            }
        });

        // Calculate subTotal
        if (updatedProcurementDetails.discount) {
            // total = total - updatedProcurementDetails.discount;
            let discountAmount =
                (updatedProcurementDetails.discount / 100) * total; // Calculate the discount amount
            total -= discountAmount;
        } else {
            updatedProcurementDetails.discount = 0;
        }
        subTotal = total;

        // Calculate GST amounts
        if (updatedProcurementDetails.gstRequired) {
            updatedProcurementDetails.gstDetails.forEach((gstDetail) => {
                gstDetail.gstAmount = Number(
                    Number.parseFloat((gstDetail.rate * total) / 100).toFixed(2)
                );
                toatlGstAmount += gstDetail.gstAmount;
            });
            total = total + toatlGstAmount;
        } else {
            toatlGstAmount = 0;
        }

        // Calculate total with freight
        if (details.InwardingRecords.freightCharge) {
            total = total + details.InwardingRecords.freightCharge;
        } else {
            updatedProcurementDetails.freight = 0;
        }

        // Calculate total with transportation charge
        if (updatedProcurementDetails.transportationCharge) {
            total = total + updatedProcurementDetails.transportationCharge;
        } else {
            updatedProcurementDetails.transportationCharge = 0;
        }

        // Update procurementDetails with calculated values
        updatedProcurementDetails.totalQty = +totalQty;
        updatedProcurementDetails.subTotal = +subTotal;
        updatedProcurementDetails.grandTotal = +total;
        presicionDiff =
            Number(total)?.toFixed(2) -
            Number(Number.parseFloat(subTotal).toFixed(2)) -
            Number(Number.parseFloat(toatlGstAmount).toFixed(2)) +
            Number(
                Number.parseFloat(updatedProcurementDetails.discount).toFixed(2)
            ) -
            Number(
                Number.parseFloat(
                    updatedProcurementDetails.transportationCharge
                ).toFixed(2)
            ) -
            Number(
                Number.parseFloat(updatedProcurementDetails.freight).toFixed(2)
            );
        updatedProcurementDetails.presicionDiff =
            Number.parseFloat(presicionDiff).toFixed(2);

        // Update state with new values
        setTransportationCharge(
            updatedProcurementDetails?.transportationCharge
        );
        setFreightCharge(details.InwardingRecords.freightCharge);
        setFreightChargeWOGst(details.InwardingRecords.freightCharge);
        setGstAmounts(toatlGstAmount);
        setGstOriginalAmount(toatlGstAmount);
        setEditableFields({
            ...editableFields,
            gstAmounts: updatedProcurementDetails?.gstDetails,
        });
        setUpdatedMat(updatedProcurementDetails.grandTotal);

        // Update the requested price for the material at Inwarding approvals
        setDetails((prevState) => ({
            ...prevState,
            InwardingRecords: {
                ...prevState.InwardingRecords,
                inwardedRate: event.target.value,
            },
        }));

        // updating the procurementDetails
        setProcurementDetails(updatedProcurementDetails);

        // Return the updated procurementDetails
        // return updatedProcurementDetails;
    };

    // function to handle change in freight charges
    const freightChargesChangeHandler = (event) => {
        if (+event.target.value < 0)
            return props.setSnackInfo(
                "Please Enter Value Greater than 0",
                "warning"
            );
        setFreightCharge(+event.target.value);
        setFreightChargeWOGst(+event.target.value);
        setFreightGstDetails({ ...freightGstDetails, rate: 0 });
        const procDetailObj = { ...procurementDetails };
        procDetailObj.grandTotal =
            procDetailObj?.grandTotal - freightCharge + +event.target.value;
        // procDetailObj.freight = +event.target.value;

        setProcurementDetails(procDetailObj);
        setEditableFields({
            ...editableFields,
            freightCharge: +event.target.value,
        });
    };

    // Function to Open Remarks Modal
    const openRemarksModalHandler = (status, type, materialDetails) => {
        setApprovalType(type);
        setApprovingMaterialDetails(materialDetails);
        if (status === "Approved") {
            setTextContent("Approval");
            setOpenApproveRemarksModal(true);
        }
        if (status === "Rejected") {
            setTextContent("Rejection");
            setOpenRejectRemarksModal(true);
        }
        setValue(status);
    };

    // Funtion to close approve Remarks Modal
    const closeApproveRemarksModalHandler = () => {
        setOpenApproveRemarksModal(false);
        setRemarks("");
    };

    // Funtion to close reject Remarks Modal
    const closeRejectRemarksModalHandler = () => {
        setOpenRejectRemarksModal(false);
        setRejectionReason("");
        setRemarks("");
    };

    // Funtion to get type of the file do display
    const getFileType = (url) => {
        const extension = url?.split(".").pop()?.toLowerCase();
        if (extension === "pdf") {
            return "pdf";
        } else if (
            extension === "jpg" ||
            extension === "jpeg" ||
            extension === "png" ||
            extension === "gif"
        ) {
            return "image";
        } else {
            return "unknown";
        }
    };

    // function to handle the rejection reason
    const handleChooseRejectionReason = (event) => {
        try {
            setRejectionReason(event.target.value);
            if (event.target.value !== "OTHERS") {
                setRemarks(event.target.value);
            } else {
                setRemarks("");
            }
        } catch (error) {
            console.error("Error -> ", error);
        }
    };

    // function to open the all remarks dialog box
    const showAllRemarksHandler = () => {
        try {
            setOpenAllRemarksDailog(true);
        } catch (error) {
            console.error("Error -> ", error);
        }
    };

    // function to download procurements
    const poDownloadHandler = () => {
        try {
            // Downloading the po when clicked on the PO Number
            window.open(procurementDetails.poLink);
        } catch (error) {
            console.error("Error -> ", error);
        }
    };

    return (
        <div>
            {/* PO Invoice Modal */}
            <Modal
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                title={`New Inwarding Approval | ${selectedOrderId}`}
                centered
                open={invoiceModal}
                onCancel={props.CLOSE_MODAL_HANDLER}
                width={1500}
                maskClosable={true}
                footer={null}
            >
                <div style={{ display: "flex", width: "100%" }}>
                    <div
                        style={{
                            border: "1px solid #000",
                            flex: 1,
                            padding: "2px",
                        }}
                    >
                        <div
                            className="container"
                            style={{ width: "100%", marginTop: "2%" }}
                        >
                            <div>
                                <div>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td
                                                    rowSpan="3"
                                                    style={{ width: "50%" }}
                                                >
                                                    <div className="invoice">
                                                        Invoice to:
                                                    </div>
                                                    <div className="invoice-to">
                                                        <b>
                                                            Samika Design
                                                            Solutions Pvt Ltd.
                                                        </b>
                                                        <div>
                                                            #17, 18th Cross Rd,
                                                            Sector 3, HSR
                                                            Layout, Bengaluru -
                                                            560102
                                                        </div>
                                                        <div className="gstno">
                                                            Gst
                                                            No-29AAWCS3842H1ZO
                                                        </div>
                                                        <div>
                                                            State Name :
                                                            Karnataka, Code : 29
                                                        </div>
                                                        <div>
                                                            E-Mail:
                                                            sales@decorpot.com
                                                        </div>
                                                    </div>
                                                </td>
                                                <td style={{ width: "25%" }}>
                                                    <div>Voucher No.</div>
                                                    <div className="vou-no">
                                                        <b>
                                                            {
                                                                procurementDetails?.orderId
                                                            }
                                                        </b>
                                                    </div>
                                                </td>
                                                <td style={{ width: "25%" }}>
                                                    <div>Dated:</div>
                                                    <div className="vou-no">
                                                        <b>
                                                            {moment(
                                                                procurementDetails?.createdAt
                                                            ).format(
                                                                "DD-MM-YYYY"
                                                            )}
                                                        </b>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ width: "25%" }}>
                                                    &nbsp;
                                                </td>
                                                <td style={{ width: "25%" }}>
                                                    <div>
                                                        Mode/Terms of Payment
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ width: "25%" }}>
                                                    <div>
                                                        Supplier's Ref./Order
                                                        No.
                                                    </div>
                                                    <div className="vou-no">
                                                        {/* 
                                                        <b>
                                                            {
                                                                procurementDetails?.orderId
                                                            }
                                                        </b>
                                                        */}
                                                        <Button
                                                            onClick={poDownloadHandler}
                                                            color="secondary"
                                                            variant="outlined"
                                                        >
                                                            <b>
                                                                { procurementDetails?.orderId }
                                                            </b>
                                                        </Button>
                                                    </div>
                                                </td>
                                                <td style={{ width: "25%" }}>
                                                    <div>
                                                        Other
                                                        Reference(s)/Comments
                                                    </div>
                                                    <div className="vou-no">
                                                        <b>
                                                            {
                                                                procurementDetails?.comment
                                                            }
                                                        </b>
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td
                                                    rowSpan="2"
                                                    style={{ width: "50%" }}
                                                >
                                                    <div className="invoice">
                                                        Supplier
                                                    </div>
                                                    <div className="invoice-to">
                                                        <b>
                                                            {
                                                                procurementDetails
                                                                    ?.vendorId
                                                                    ?.name
                                                            }
                                                        </b>
                                                        <div>
                                                            {
                                                                procurementDetails
                                                                    ?.vendorId
                                                                    ?.address
                                                            }
                                                        </div>
                                                        <div className="row">
                                                            <div
                                                                className="col-md-2"
                                                                style={{
                                                                    float: "left",
                                                                }}
                                                            >
                                                                GSTIN/UIN
                                                            </div>
                                                            <div className="col-md-10">
                                                                :&nbsp;
                                                                {
                                                                    procurementDetails
                                                                        ?.vendorId
                                                                        ?.gstinNumber
                                                                }
                                                            </div>
                                                            <div className="row">
                                                                <div
                                                                    className="col-md-2"
                                                                    style={{
                                                                        float: "left",
                                                                    }}
                                                                >
                                                                    State Name
                                                                </div>
                                                                <div className="col-md-10">
                                                                    :&nbsp;Karnataka,
                                                                    Code : 29
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>Inwarding Id</div>
                                                    <div className="vou-no">
                                                        <b>
                                                            {
                                                                details
                                                                    ?.InwardingRecords
                                                                    ?.inwardingId
                                                            }
                                                        </b>
                                                    </div>
                                                </td>
                                                <td>
                                                    {/*
                                                    <div>Destination</div>
                                                    */}
                                                    <div>
                                                        <Button
                                                            variant="outlined"
                                                            onClick={
                                                                showAllRemarksHandler
                                                            }
                                                            color="secondary"
                                                        >
                                                            Show Remarks
                                                        </Button>
                                                    </div>
                                                </td>
                                                <td>
                                                    
                                                    {/* <div>SHOW GRN</div> */}
                                                   
                                                    <div>
                                                        <Button
                                                            variant="outlined"
                                                            onClick={handleOpenGRN}
                                                            color="secondary"
                                                        >
                                                            SHOW GRN
                                                        </Button>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan="1">
                                                    <div>Terms of Delivery</div>
                                                </td>
                                                <td style={{ width: "25%" }}>
                                                    <div>Invoice No.</div>
                                                    <div className="vou-no">
                                                        <b>
                                                            {
                                                                details
                                                                    ?.InwardingRecords
                                                                    ?.invoiceNumber
                                                            }
                                                        </b>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div>
                                    <Table
                                        size="small"
                                        aria-label="custom pagination table"
                                    >
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Sl. No.</TableCell>
                                                <TableCell>
                                                    Description of Goods
                                                </TableCell>
                                                <TableCell>Due On</TableCell>
                                                <TableCell>Quantity</TableCell>
                                                <TableCell>Rate</TableCell>
                                                <TableCell>per</TableCell>
                                                <TableCell>Disc. %</TableCell>
                                                <TableCell>Amount</TableCell>
                                                <TableCell>Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableHead>
                                            {procurementDetails?.materials?.map(
                                                (material, index) =>
                                                    material.isAdded && (
                                                        <TableRow key={index}>
                                                            <TableCell>
                                                                {index + 1}
                                                            </TableCell>
                                                            <TableCell>
                                                                <div>
                                                                    <b>
                                                                        {
                                                                            material
                                                                                ?.materialId
                                                                                ?.code
                                                                        }
                                                                    </b>
                                                                </div>
                                                                <br />
                                                                <div className="desc">
                                                                    [
                                                                    {material
                                                                        ?.materialId
                                                                        ?.aliasName
                                                                        ? material
                                                                              ?.materialId
                                                                              ?.aliasName
                                                                        : material
                                                                              ?.materialId
                                                                              .name}
                                                                    ]
                                                                </div>
                                                                <br />
                                                                {material?.remark && (
                                                                    <div className="desc">
                                                                        {
                                                                            material?.remark
                                                                        }
                                                                    </div>
                                                                )}
                                                            </TableCell>
                                                            <TableCell>
                                                                45 Days
                                                            </TableCell>
                                                            <TableCell>
                                                                {/* {
                                                                    details
                                                                        ?.InwardingRecords
                                                                        ?.inwardedQty
                                                                } */}
                                                                {material?.inwardedQty}
                                                            </TableCell>
                                                            <TableCell>
                                                                <FormControl
                                                                    style={{
                                                                        width: 200,
                                                                    }}
                                                                >
                                                                    <TextField
                                                                        style={{
                                                                            margin: "5px",
                                                                        }}
                                                                        size="small"
                                                                        id={`requestedPrice-${index}`}
                                                                        label="Requested Price"
                                                                        value={
                                                                            material?.requestedPrice
                                                                        }
                                                                        variant="outlined"
                                                                        name={`requestedPrice-${index}`}
                                                                        type="number"
                                                                        onChange={(
                                                                            e
                                                                        ) =>
                                                                            materialPriceChangeHandler(
                                                                                index,
                                                                                e
                                                                            )
                                                                        }
                                                                    />
                                                                </FormControl>
                                                            </TableCell>
                                                            <TableCell>
                                                                {
                                                                    material
                                                                        ?.unitId
                                                                        .name
                                                                }
                                                            </TableCell>
                                                            <TableCell>
                                                                {
                                                                    procurementDetails?.discount
                                                                }
                                                            </TableCell>
                                                            {/* <TableCell >₹{material?.materialTotal?.toFixed(2)}</TableCell> */}
                                                            <TableCell>
                                                                ₹
                                                                {(
                                                                    material?.materialTotal?.toFixed(
                                                                        2
                                                                    ) -
                                                                    (procurementDetails?.discount *
                                                                        material?.materialTotal) /
                                                                        100
                                                                ).toFixed(2)}
                                                            </TableCell>
                                                            <TableCell>
                                                                <div
                                                                    style={{ isplay: "flex", width: "100%" }}
                                                                >
                                                                    <div
                                                                        style={{ flex: 1, padding: "1px" }}
                                                                    >
                                                                        <Button
                                                                            onClick={() => openRemarksModalHandler( "Approved", "Single", material )}
                                                                            variant="contained"
                                                                            size="small"
                                                                            style={{ background: "#2b7636", }}
                                                                        >
                                                                            Approve
                                                                        </Button>
                                                                    </div>
                                                                    <div
                                                                        style={{
                                                                            flex: 1,
                                                                            padding: "1px",
                                                                        }}
                                                                    >
                                                                        <Button
                                                                            onClick={() => openRemarksModalHandler( "Rejected", "Single", material )}
                                                                            color="secondary"
                                                                            variant="outlined"
                                                                            size="small"
                                                                        >
                                                                            Reject
                                                                        </Button>
                                                                    </div>
                                                                </div>
                                                            </TableCell>
                                                            {/* <TableCell>{(material?.materialTotal?.toFixed(2))} - {((procurementDetails?.discount * material?.materialTotal) / 100).toFixed(2)} = ₹{(material?.materialTotal?.toFixed(2) - (procurementDetails?.discount * material?.materialTotal) / 100).toFixed(2)}</TableCell> */}
                                                        </TableRow>
                                                    )
                                            )}
                                        </TableHead>
                                    </Table>
                                </div>

                                <div>
                                    <Table>
                                        <TableBody>
                                            <TableRow key="1">
                                                <TableCell>Total Qty</TableCell>
                                                <TableCell>
                                                    {
                                                        procurementDetails?.totalQty
                                                    }
                                                </TableCell>
                                            </TableRow>
                                            {/*
                                            <TableRow key="2">
                                                <TableCell>
                                                    <i>Discount</i>
                                                </TableCell>
                                                <TableCell>{procurementDetails?.discount}%</TableCell>
                                            </TableRow>
                                            */}
                                            <TableRow key="2">
                                                <TableCell>
                                                    Freight Approved (W/O GST)
                                                </TableCell>
                                                <TableCell>
                                                    ₹
                                                    {procurementDetails?.totalFreightApproved?.toFixed(
                                                        2
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow key="3">
                                                <TableCell>
                                                    <i>Freight Charge</i>
                                                </TableCell>
                                                <TableCell>
                                                    <Box display="flex" alignItems="center" justifyContent="space-between">
                                                        <FormControl style={{ width: '48%' }}>
                                                            <TextField
                                                                style={{ margin: '5px' }}
                                                                size="small"
                                                                id="outlined-basic"
                                                                label="Freight Charge"
                                                                value={freightCharge}
                                                                variant="outlined"
                                                                name="freight charge"
                                                                type="number"
                                                                onChange={(e) => freightChargesChangeHandler(e)}
                                                            />
                                                        </FormControl>
                                                        <Autocomplete
                                                            value={freightGstDetails?.rate}
                                                            onChange={(e, value) => freightGstRateChangeHandler(e, value)}
                                                            id="percent"
                                                            options={freightGstPercent}
                                                            getOptionLabel={(option) => `${option}%`}
                                                            style={{ width: '48%' }}
                                                            renderInput={(params) => <TextField {...params} label="Select GST percent for Freight" fullWidth variant="outlined" />}
                                                        />
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                            <TableRow key="4">
                                                <TableCell>
                                                    <i>GST Rate</i>
                                                </TableCell>
                                                <TableCell>
                                                    {/* <FormControl style={{ width: 300 }}>
                                                        <TextField
                                                            style={{ margin: "5px" }}
                                                            size="small"
                                                            id="outlined-basic"
                                                            label="Transportation Charge"
                                                            value={transportationCharge}
                                                            variant="outlined"
                                                            name="Transportation Charge"
                                                            type="number"
                                                            onChange={(e) =>
                                                                transportationChargesChangeHandler(e)
                                                            }
                                                        />
                                                    </FormControl> */}
                                                    {procurementDetails?.gstDetails
                                                        ? procurementDetails
                                                              .gstDetails
                                                              .length !== 0
                                                            ? procurementDetails
                                                                  .gstDetails[0]
                                                                  .rate
                                                                ? procurementDetails
                                                                      .gstDetails[0]
                                                                      .rate
                                                                : "N/A"
                                                            : "N/A"
                                                        : "N/A"}
                                                    %
                                                </TableCell>
                                            </TableRow>
                                            <TableRow key="5">
                                                <TableCell>
                                                    <i>Gst Charge</i>
                                                </TableCell>
                                                <TableCell>
                                                    {/* <FormControl style={{ width: 300 }}>
                                                        <TextField
                                                            style={{ margin: "5px" }}
                                                            size="small"
                                                            id="outlined-basic"
                                                            label="Gst Charge"
                                                            value={gstAmounts}
                                                            variant="outlined"
                                                            name="Gst Charge"
                                                            type="number"
                                                            onChange={(e) => gstChangeHandler(e)}
                                                        />
                                                    </FormControl> */}
                                                    {gstAmounts?.toFixed(2)}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow key="6">
                                                <TableCell>
                                                    Total Amount
                                                </TableCell>
                                                <TableCell>
                                                    ₹
                                                    {procurementDetails?.grandTotal?.toFixed(
                                                        2
                                                    )}
                                                    {/* ₹{Math.round(procurementDetails?.grandTotal)} */}
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        style={{
                            border: "1px solid #000",
                            flex: 1,
                            padding: "",
                        }}
                    >
                        <EyeFilled
                            style={{ cursor: 'pointer', fontSize: '20px', color: '#1890ff' }}
                            onClick={handleViewFile}
                        />

                        {isFilePreviewVisible && (
                            <div style={{ marginTop: '20px' }}>
                                {getFileType(details?.InwardingRecords?.invoice) ===
                                    "pdf" ? (
                                    <iframe
                                    title="PDF Preview"
                                        src={`https://docs.google.com/gview?url=${details?.InwardingRecords?.invoice}&embedded=true`}
                                        style={{
                                            width: "fit-content",
                                            height: "800px",
                                            border: "none",
                                        }}
                                        allow="fullscreen"
                                    />
                                ) :
                                    getFileType(details?.InwardingRecords?.invoice) ===
                                        "image" ? (
                                        <img
                                            src={details?.InwardingRecords?.invoice}
                                            alt="Image"
                                            style={{ width: '100%', height: 'auto' }}
                                        />
                                    ) : (
                                        <p style={{ color: 'red', padding: '10%' }}>
                                            <b>File Format Not Supported</b>
                                        </p>
                                    )}
                            </div>
                        )}
                    </div>
                </div>

                <DialogActions>
                    <Button
                        onClick={() => openRemarksModalHandler("Rejected", "All", null)}
                        color="secondary"
                        variant="outlined"
                    >
                        Reject
                    </Button>
                    <Button
                        onClick={() => openRemarksModalHandler("Approved", "All", null)}
                        color="primary"
                        variant="contained"
                        style={{ background: "#2b7636", margin: 5 }}
                    >
                        Approve
                    </Button>
                </DialogActions>
            </Modal>

            {/* Approve Remarks Dialog Box  */}
            <div>
                <Dialog
                    open={openApproveRemarksModal}
                    onClose={closeApproveRemarksModalHandler}
                    aria-labelledby="form-dialog-title"
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogContent>
                        <DialogContentText>
                            Enter {textContent} Remarks
                        </DialogContentText>
                        <TextField
                            id="remarks"
                            name="Remarks"
                            label="Add Remarks"
                            variant="outlined"
                            type="text"
                            value={remarks}
                            onChange={remarksInputHandler}
                            fullWidth
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant="outlined"
                            onClick={closeApproveRemarksModalHandler}
                            color="secondary"
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={handleFinanceInwardingAction}
                            variant="contained"
                            color="primary"
                            style={{ background: "#2b7636", margin: 5 }}
                        >
                            Submit
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>

            {/* Reject Remarks Dialog Box  */}
            <div>
                <Dialog
                    open={openRejectRemarksModal}
                    onClose={closeRejectRemarksModalHandler}
                    aria-labelledby="form-dialog-title"
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogContent>
                        <DialogContentText>
                            Choose {textContent} Reason
                        </DialogContentText>
                        <FormControl
                            style={{ width: "100%", marginTop: "0.4rem" }}
                        >
                            <TextField
                                select
                                labelId="project-doc"
                                label="Choose Rejection Reason"
                                variant="outlined"
                                value={rejectionReason}
                                onChange={(e) => handleChooseRejectionReason(e)}
                            >
                                <MenuItem value="QUANTITY">Quantity</MenuItem>
                                <MenuItem value="GST">GST</MenuItem>
                                <MenuItem value="FREIGHT">Freight</MenuItem>
                                <MenuItem value="AMOUNT">Amount</MenuItem>
                                <MenuItem value="OTHERS">Others</MenuItem>
                            </TextField>
                        </FormControl>
                        {rejectionReason === "OTHERS" && (
                            <>
                                <DialogContentText>
                                    Enter {textContent} Remarks
                                </DialogContentText>
                                <TextField
                                    id="remarks"
                                    name="Remarks"
                                    label="Add Remarks"
                                    variant="outlined"
                                    type="text"
                                    value={remarks}
                                    onChange={remarksInputHandler}
                                    fullWidth
                                />
                            </>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant="outlined"
                            onClick={closeRejectRemarksModalHandler}
                            color="secondary"
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={handleFinanceInwardingAction}
                            variant="contained"
                            color="primary"
                            style={{ background: "#2b7636", margin: 5 }}
                        >
                            Submit
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>

            {/* All Remarks Display Dialog Box  */}
            <div>
                <Dialog
                    open={openAllRemarksDailog}
                    onClose={() => setOpenAllRemarksDailog(false)}
                    aria-labelledby="form-dialog-title"
                    maxWidth="md"
                    fullWidth
                >
                    <DialogContent>
                        <DialogContentText>Remarks</DialogContentText>
                        <Table
                            className={classes.table}
                            size="small"
                            aria-label="customized table"
                            stickyHeader
                        >
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell>Action</StyledTableCell>
                                    <StyledTableCell>Remarks</StyledTableCell>
                                    <StyledTableCell>
                                        Remarks Date
                                    </StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {details?.InwardingRecords?.remarks?.length >
                                0 ? (
                                    details?.InwardingRecords?.remarks.map(
                                        (el, i) => {
                                            return (
                                                <TableRow key={i + 1}>
                                                    <StyledTableCell>
                                                        {el?.action}
                                                    </StyledTableCell>
                                                    <StyledTableCell>
                                                        {el?.msgBody}
                                                    </StyledTableCell>
                                                    <StyledTableCell>
                                                        {new Date(
                                                            el.date
                                                        ).toLocaleDateString()}
                                                    </StyledTableCell>
                                                </TableRow>
                                            );
                                        }
                                    )
                                ) : (
                                    <p>No Remarks To Show</p>
                                )}
                            </TableBody>
                        </Table>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant="outlined"
                            onClick={() => setOpenAllRemarksDailog(false)}
                            color="secondary"
                        >
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={openGRN} onClose={handleCloseGRN} maxWidth="lg" fullWidth>
                    <DialogTitle>GRN Document</DialogTitle>

                    <DialogContent dividers>
                        <div style={{ width: "100%", height: "800px", border: "1px solid #000" }}>
                            {grnUrl ? (
                                <iframe
                                    src={grnUrl}
                                    title="GRN Viewer"
                                    style={{ width: "100%", height: "100%", border: "none" }}
                                />
                            ) : (
                                <p>No GRN Document Available</p>
                            )}
                        </div>
                    </DialogContent>

                    {/* Close button aligned to the right */}
                    <DialogActions style={{ justifyContent: "flex-end" }}>
                        <Button onClick={handleCloseGRN} color="primary" variant="contained">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </div>
    )
}

export default connect(null, { setLoading, setSnackInfo })(
    DetailsModalOfInwarding
);